import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconBookmarkStyle0 = cosmosIconCss;

const CosmosIconBookmark$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBookmark extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e1a0945927658bef8b43c526e64c4172875a6061', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '0ab82288bcec5f5ca341089061fcb02b049a9831', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ee98a92ac19b337a8da5caac814eddce9ce2853c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.5 4.5v12.11l-4.16-3.77a.5.5 0 0 0-.68 0L6.5 16.61V4.5h9ZM5.5 3a.5.5 0 0 0-.5.5v15.6a.4.4 0 0 0 .67.29L11 14.56l5.33 4.83a.4.4 0 0 0 .67-.29V3.5a.5.5 0 0 0-.5-.5h-11Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconBookmarkStyle0; }
}, [1, "cosmos-icon-bookmark", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-bookmark"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-bookmark":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBookmark$1);
            }
            break;
    } });
}

const CosmosIconBookmark = CosmosIconBookmark$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBookmark, defineCustomElement };
